module.exports = __webpack_public_path__ + "static/media/express.c282c7b4.svg";